// extracted by mini-css-extract-plugin
module.exports = {"title":"fMVuv2PrdFspKwkvNp73e","loginLink":"_2VqsVl8gmFoAYUdgQRhXS7","loginButtonContainer":"_26N563KXiMz-vlIwkgeLlK"};